import { render } from "./NewsNav.vue?vue&type=template&id=2716e4c4&scoped=true"
import script from "./NewsNav.vue?vue&type=script&lang=js"
export * from "./NewsNav.vue?vue&type=script&lang=js"

import "./NewsNav.vue?vue&type=style&index=0&id=2716e4c4&scoped=true&lang=css"

import exportComponent from "D:\\eestec sajt trenutni\\eestec.etf.rs\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2716e4c4"]])

export default __exports__